import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'dashboard',
    alias: '/vuot-tram',
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: '/ve-thang',
    name: 've-thang',
    component: () => import('../views/Ticket.vue'),
  },
  {
    path: '/giay-to-xe',
    name: 'giay-to-xe',
    component: () => import('../views/Giaytoxe.vue'),
  },
  {
    path: '/dang-nhap',
    name: 'dang-nhap',
    component: () => import('../views/Login.vue'),
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const publicPages = ['/dang-nhap'];
  const authRequired = !publicPages.includes(to.path);
  const LoginPage = publicPages.includes(to.path);
  const loggedIn = store.getters.isAuthenticated;

  if (authRequired  && !loggedIn) {
    return next('/dang-nhap');
  }
  if(LoginPage && loggedIn){
    return next('/');
  }
  next();
});
export default router
